import { Button } from "@/shared/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Textarea } from "@/shared/components/ui/textarea";
import { useEffect, useState } from "react";

export function ManualJsonDialog({
    open,
    onOpenChange,
    onSubmit,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit: (jsonText: string) => Promise<{ ok: true } | { ok: false; error: string }>;
}) {
    const [text, setText] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) return;
        setText("");
        setError("");
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>JSON 직접 입력</DialogTitle>
                </DialogHeader>

                <div className="space-y-2">
                    <div className="text-sm text-muted-foreground">
                        유효한 JSON 형식으로 입력해주세요. <b>trans_id</b> 필드와 <b>org.eng_identifier</b> 필드가 포함되어야 합니다.
                    </div>
                    <Textarea
                        value={text}
                        onChange={(e) => {
                            setError("");
                            setText(e.target.value);
                        }}
                        placeholder='{"trans_id":"...","org":{"eng_identifier":"..."}}'
                        className="min-h-[220px]"
                    />
                    {error && (
                        <div className="rounded-md border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{error}</div>
                    )}
                </div>

                <DialogFooter>
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>
                        취소
                    </Button>
                    <Button
                        onClick={async () => {
                            const res = await onSubmit(text);
                            if (!res.ok) {
                                setError(res.error);
                                return;
                            }
                            onOpenChange(false);
                        }}
                    >
                        전송
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}